/**
 * تحويل أسماء الأعمدة بين الواجهة (camelCase) وقاعدة البيانات (snake_case).
 *
 * التحويل يمسّ مفاتيح الصف فقط، ولا يمسّ القيم. هذا مهم لأن قيم JSON
 * (مثل settings و recurrence و assigneeScope) قد تحتوي مفاتيح خاصة يجب
 * ألا تُعاد كتابتها.
 */

export function camelToSnake(key: string): string {
  return key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function snakeToCamel(key: string): string {
  return key.replace(/_([a-z0-9])/g, (_, letter: string) => letter.toUpperCase());
}

export function rowToDb(row: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(row)) {
    result[camelToSnake(key)] = value;
  }
  return result;
}

export function rowFromDb<T>(row: Record<string, unknown>): T {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(row)) {
    result[snakeToCamel(key)] = value;
  }
  return result as T;
}

export function rowsFromDb<T>(rows: readonly Record<string, unknown>[]): T[] {
  return rows.map((row) => rowFromDb<T>(row));
}
